var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"Titulo","dense":"","outlined":"","hide-details":""},on:{"click:clear":_vm.clearCliente},model:{value:(_vm.titulo),callback:function ($$v) {_vm.titulo=$$v},expression:"titulo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }